import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { BannerLayout, BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';
import ChangeBillingInfoButton from '../../pages/settings/payment-and-subscription/components/change-billing-info-button';

import style from './header-notification-banner.module.less';
import buttonTextStyle from 'ui-components/components/button/button-text.module.less';

export const PastDueBanner = ({ userHasAccountManagementRole, onClickTrack, onConfirmClickTrack }) => {
  return (
    <BannerMessageV2
      buttons={
        userHasAccountManagementRole && (
          <ChangeBillingInfoButton
            className={classnames(style['select-plan-button'], buttonTextStyle['button-text'])}
            onClickTrack={onClickTrack}
            onConfirmClickTrack={onConfirmClickTrack}
          >
            <FormattedMessage {...messages.updateBillingInfo} />
          </ChangeBillingInfoButton>
        )
      }
      className={style['banner-padding']}
      content={<Text textType={TextType.Paragraph} value={messages.paymentDueMessage} />}
      layout={BannerLayout.Default}
      status={BannerStatus.Error}
    />
  );
};

PastDueBanner.propTypes = {
  userHasAccountManagementRole: PropTypes.bool.isRequired,
  onClickTrack: PropTypes.func.isRequired,
  onConfirmClickTrack: PropTypes.func.isRequired,
};
